import React from 'react';
import { useNavigate } from 'react-router-dom'; // Using useNavigate for navigation
import Navbar from '../components/Navbar'; // Adjust the path as needed
import '../styles/CAD.css';

const CorporateSecurityAwarenessTraining = () => {
    const navigate = useNavigate();

    // For demonstration, Learn More buttons currently redirect to Google.
    // Replace with your actual paths or navigation logic as needed.
    const handleNavigation = () => {
        navigate('/contact');
    };

    return (
        <>
            <Navbar />
            <div className="custom-app-development">
                <div className="content-box">
                    <header className="header">
                        <h1>Corporate & Security Awareness Training</h1>
                        <p className="tagline">
                            Elevate your team's capabilities with dynamic tech training and corporate workshops.
                        </p>
                    </header>
                    
                    <section className="introduction">
                        <p>
                            In an era of evolving cyber threats and rapid technological change, a well-trained workforce is your first line of defense. Our Corporate & Security Awareness Training programs are designed to empower your employees with the knowledge and skills needed to identify, prevent, and respond to security threats—while also fostering a culture of continuous learning.
                        </p>
                    </section>
                    
                    <section className="why-choose-us">
                        <h2>Why Choose Our Training Programs?</h2>
                        <p>
                            We deliver engaging, interactive training sessions that combine real-world scenarios with hands-on exercises. Our expert instructors customize the content to match your corporate needs, ensuring your team not only understands the importance of security but also learns practical strategies to safeguard your assets.
                        </p>
                    </section>
                    
                    <section className="tech-stack">
                        <h2>Training Methodology & Approach</h2>
                        <p>
                            Our comprehensive training modules include:
                        </p>
                        <ul>
                            <li><strong>Cybersecurity Fundamentals:</strong> Understanding the basics of cybersecurity and the current threat landscape.</li>
                            <li><strong>Phishing & Social Engineering:</strong> Identifying common tactics used in phishing and social engineering attacks.</li>
                            <li><strong>Data Protection & Compliance:</strong> Best practices for data privacy, regulatory compliance, and secure handling of sensitive information.</li>
                            <li><strong>Interactive Workshops:</strong> Hands-on simulations and group exercises to reinforce learning and build practical skills.</li>
                        </ul>
                    </section>
                    
                    <section className="secure-practices">
                        <h2>Empower & Protect Your Organization</h2>
                        <p>
                            Our training programs are designed not only to educate but also to transform your organizational culture. By investing in your team's skill development, you create a proactive environment where every employee plays a role in maintaining corporate security.
                        </p>
                    </section>
                    
                    <section className="services">
                        <h2>Our Training Offerings</h2>
                        <div className="service-container">
                            <div className="service-box">
                                <h3>Cybersecurity Fundamentals Training</h3>
                                <p>
                                    Equip your workforce with the essential knowledge to recognize and respond to cyber threats.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Phishing Simulation & Awareness</h3>
                                <p>
                                    Conduct realistic phishing simulations to test and improve your team's resilience.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Corporate IT Security Workshops</h3>
                                <p>
                                    Interactive sessions designed to provide hands-on experience in protecting corporate assets.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Compliance & Policy Training</h3>
                                <p>
                                    Understand and implement best practices for data protection, privacy, and regulatory compliance.
                                </p>
                                <button className="learn-more" onClick={handleNavigation}>
                                    Learn More
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default CorporateSecurityAwarenessTraining;
